import { Box, Flex } from 'reflexbox';
import { useTranslation } from 'react-i18next';
import { Route, Switch } from 'react-router';

import * as graphql from 'generated/graphql';
import LearningEventsList from 'packages/kakapo-ui-application/pages/learning/components/LearningEventsList';
import { SectionTitle } from 'packages/kakapo-ui-kit/components/common/Headings';
import Spinner from 'packages/kakapo-ui-kit/components/common/Spinner';
import Paragraph from 'packages/kakapo-ui-kit/components/common/Paragraph';

export default function LearningMyEventsContainer() {
	const { t } = useTranslation();

	const { data } = graphql.useLearningMyEventsQuery({
		variables: { first: 100 },
	});

	return (
		<>
			<Box mb={4}>
				<SectionTitle>{t('learning.events.myProposals.title')}</SectionTitle>
				<Box mt={3}>
					<Paragraph color="slateBlue">{t('learning.events.myProposals.description')}</Paragraph>
				</Box>
			</Box>

			<Flex flexWrap="wrap">
				{data ? (
					<LearningEventsList
						events={data.viewer.learningEventProposals as graphql.LearningEventConnection}
					/>
				) : (
					<Spinner size="18px" isLoading />
				)}
			</Flex>
		</>
	);
}
